export default __webpack_public_path__ + "static/media/uncertaintyThicknessSurficialStability.5f44e421.png";